import { useMutation } from 'react-query';

import { deleteV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldId } from 'src/client/spendesk-api';
import { useCompanyId } from 'src/core/modules/app/hooks/useCompanyId';

import { useInvalidateSyncSettingsQuery } from './useGetSyncSettings';

type DeleteSyncSettingsOptions = {
  onSuccess: () => void;
  onError?: () => void;
};

export const useDeleteSyncSettings = (input?: DeleteSyncSettingsOptions) => {
  const companyId = useCompanyId();
  const invalidateSyncSettingsQuery = useInvalidateSyncSettingsQuery();

  const { mutate, isLoading } = useMutation({
    mutationKey: ['deleteSyncSettings', companyId],
    mutationFn: async (fieldId: string) => {
      const response =
        await deleteV2ApiCompanyIdAccountingIntegrationsSyncSettingsFieldId({
          path: {
            fieldId,
            companyId,
          },
        });

      if (response.statusCode === 200) {
        return;
      }

      throw new Error('Failed to update sync settings');
    },
    onSuccess: () => {
      invalidateSyncSettingsQuery();
      input?.onSuccess();
    },
    onError: input?.onError,
  });

  return {
    isPending: isLoading,
    deleteSyncSettings: mutate,
  };
};
